/**
 * Parse a timestamp for chart binning. Date-only strings (YYYY-MM-DD) are
 * treated as calendar dates in local time — not UTC midnight — so May 1
 * stays in May regardless of timezone.
 */
export function parseCalendarDate(value) {
  if (value == null || value === '') return null;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }
  const s = String(value);
  const dayPart = s.includes('T') ? s.split('T')[0] : s.slice(0, 10);
  if (/^\d{4}-\d{2}-\d{2}$/.test(dayPart)) {
    const [y, m, d] = dayPart.split('-').map(Number);
    return new Date(y, m - 1, d);
  }
  return parseApiDate(s);
}

/** Parse API timestamps that are UTC but may omit the trailing Z. */
export function parseApiDate(iso) {
  if (!iso) return null;
  const s = String(iso);
  if (s.endsWith('Z') || /[+-]\d{2}:\d{2}$/.test(s)) return new Date(s);
  return new Date(`${s}Z`);
}

export function formatApiDateTime(iso) {
  const d = parseApiDate(iso);
  if (!d || Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString(undefined, { timeZoneName: 'short' });
}
